import { useState } from 'react';
import { TagKnown } from '../../Pages/ManageTags/TagsTable';
import { FormInput, FormLabelContainer } from '../../StyledComponents/Form';
import { useUpdateTagMutation } from '../../gql/generated';
import { ModalContent } from './ModalContent';

interface UpdateTagNamePanelProps {
  tag: TagKnown;
  onClose: () => void;
}

export const UpdateTagNamePanel = (props: UpdateTagNamePanelProps) => {
  const { tag, onClose } = props;

  const [tagName, setTagName] = useState<string>(tag.tagName ?? '');
  const [updateTag, { loading, error }] = useUpdateTagMutation();

  const handleClose = () => {
    setTagName('');
    onClose();
  };

  const handleUpdateTag = async () => {
    await updateTag({
      variables: {
        input: {
          tagId: tag.tagId ?? '',
          tagName,
        },
      },
    });
    handleClose();
  };

  return (
    <ModalContent
      title="Update Tag Name"
      loading={loading}
      error={error}
      handleClose={handleClose}
      submitDisabled={loading || tagName === tag.tagName}
      handleSubmit={handleUpdateTag}
      buttonLabels={{
        loading: 'Updating Tag...',
        create: 'Update',
      }}
    >
      <FormLabelContainer>
        <FormInput
          placeholder="Enter a tag name"
          maxLength={120}
          value={tagName}
          autoCapitalize="none"
          onChange={(event): void => setTagName(event.target.value)}
        />
      </FormLabelContainer>
    </ModalContent>
  );
};
